import React, { useContext, useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { setLocale as cacheLocale } from '../../store/cache/locales';
import { flatTranslations } from './locales/translate';
import { LocaleContext } from './LocaleContext';
export var defaultLocale = 'en';
export var availableLocales = ['en'];
export var availableTranslations = { en: {} };
var intlErrorHandler = function (error) {
    // eslint-disable-next-line no-console
    console.log(error);
};
export var Intl = function (_a) {
    var children = _a.children, _b = _a.langCode, langCode = _b === void 0 ? defaultLocale : _b, _c = _a.defaultLangCode, defaultLangCode = _c === void 0 ? defaultLocale : _c, locales = _a.locales, translations = _a.translations;
    availableTranslations = flatTranslations(translations);
    availableLocales = locales;
    var _d = useContext(LocaleContext), locale = _d.locale, setLocale = _d.setLocale;
    var selectedTranslation = availableTranslations[locale];
    useEffect(function () {
        // If locale set in path, use it
        var path = window.location.pathname;
        if (path.match('/[a-z]{2}/.*')) {
            var urlLangCode = path.substring(1, 3);
            if (availableLocales.includes(urlLangCode)) {
                cacheLocale(urlLangCode);
                setLocale(urlLangCode);
            }
        }
        else if (langCode) {
            cacheLocale(langCode);
            setLocale(langCode);
        }
    }, []);
    return (React.createElement(IntlProvider, { defaultLocale: defaultLangCode, locale: locale + "-CA", messages: selectedTranslation, onError: intlErrorHandler }, children));
};
